import glamorous from 'glamorous'

import { hexToRgb } from '../../../helpers/styles'

import * as colours from '../../../styles/colours'

export const StyledLoginForm = glamorous.div({
  width: '100%',
  maxWidth: 620,
  overflow: 'hidden',
  margin: '40px 0',
  background: `${colours.white}`,
  boxShadow: `0 10px 50px 0 rgba(${hexToRgb(colours.shadow)}, 0.2)`,
})



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/pages/LoginForm/LoginForm.glamorous.tsx